import PrescriptionProposal, {
  PATH as PRESCRIPTION_PROPOSAL,
} from './PrescriptionProposal'

export default { PrescriptionProposal }
export const PATH = { PRESCRIPTION_PROPOSAL }
